/**
/**
 * SummaryIcon Component
 *
 * Displays an icon button for viewing a lesson or course summary (PDF or document).
 * The button opens the summary in a new browser tab when clicked.
 *
 * Features:
 * - Tooltip with internationalized label
 * - Icon button for summary access
 * - PropTypes and defaultProps for robust type checking
 *
 * @param {Object} props - Component props
 * @param {string} props.summary - URL to the summary document
 * @returns {JSX.Element} The rendered summary icon button
 */
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import classes from './SummaryIcon.module.css';

const SummaryIcon = props => {
  const { t } = useTranslation(['course']);

  /**
   * Handles opening the summary document in a new browser tab
   * @returns {void}
   */
  const summaryHandler = () => {
    window.open(props.summary);
  };

  return (
    <>
      <Tooltip placement="bottom" title={t('summary')}>
        <IconButton
          className={classes.summaryBtn} // Prop passed: button styling
          onClick={summaryHandler} // Prop passed: click handler for summary
        >
          <figure className={classes.summaryImg}>
            <img
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_Resumen.png"
              className={classes.img} // Prop passed: image styling
            />
          </figure>
        </IconButton>
      </Tooltip>
    </>
  );
};

/**
 * PropTypes definition for type checking and development documentation
 * Provides runtime validation and serves as inline documentation
 */
SummaryIcon.propTypes = {
  /**
   * URL to the summary document
   * Passed as prop to IconButton and used in summaryHandler
   */
  summary: PropTypes.string
};

SummaryIcon.defaultProps = {
  summary: ''
};

export default SummaryIcon;
